import React, { useEffect, useState } from 'react'
import { DangerIcon, PencilIcon } from '../../Assets/AllSvg'
import { BiPlus } from 'react-icons/bi'
import PublicDetails from '../PublicDetails/PublicDetails'
import BusinessOwners from '../BusinessOwners/BusinessOwners'
import BusinessRepresent from '../BusinessRepresent/BusinessRepresent'
import BankDetails from '../BankDetails/BankDetails'
import SecureAccount from '../SecureAccount/SecureAccount'
import BusinessDetails from '../BusinessDetails/BusinessDetails'
import { v4 as uuidv4 } from 'uuid';
import { CreateUSER_EXTENSION } from '../API/ActivatepaymentAPI'
import FullfillDetails from '../FullfillDetails/FullfillDetails'
import { toast } from 'react-toastify'
import { getUSERSet, UpdateUSER } from '../API/UserinfoAPI'

const StepSummary = ({
    setStep,
    setMainStep,
    isUpdate,
    setIsUpdate,
    businessType,
    businessDetail, setBusinessDetail,
    businessRepresent, setBusinessRepresent,
    fullfillmentDetail,  setFullfillmentDetail,
    businessOwner, setBusinessOwner,
    publicDetail, setPublicDetail,
    bankDetail, setBankDetail,
    secureAccount, SetSecureAccount,
    data, setData
}) => {
    const [requireDetails, setRequireDetails] = useState(false)
    const [requireFullfill, setRequireFullfill] = useState(false)
    const [requirePublicDetails, setRequirePublicDetails] = useState(false)
    const [requireRepresent, setRequireRepresent] = useState(false)
    const [requireOwner, setRequireOwner] = useState(false)
    const [requireBankInfo, setRequireBankInfo] = useState(false)
    const [requireAuth, setRequireAuth] = useState(false)
    
    const handlesubmit = async () => {
        const postParams = {
            createUSER_EXTENSIONInput: {
              client_id: localStorage.getItem("client_id"),
              user_id: localStorage.getItem("user"),
              email: localStorage.getItem("email"),
              activate_payment_id: uuidv4(),
              ...businessType,
              ...businessDetail,
              ...businessRepresent,
              ...businessOwner,
              ...fullfillmentDetail,
              ...publicDetail,
              ...bankDetail,
              ...secureAccount,
              industry: businessDetail.industry === 'Please select your industry…' ? '' : businessDetail.industry,
              your_product_category: 'other'
            },
        };

        const result = await CreateUSER_EXTENSION(postParams)
        if(result){
            const userData = await getUSERSet(localStorage.getItem("user"));
            const params = {
                updateUSERInput: {
                    ...userData,
                    is_active: 'Y'
                }
            }
            const activeUser = await UpdateUSER(params)
            if(activeUser){
                toast.success("Account activated successfully", { autoClose: 5000 });
            }
        } else {
            toast.error("Something went wrong", { autoClose: 5000 });
        }
    }

    const validate = () => {
        const validBusinessDetail = Object.values(businessDetail)
        validBusinessDetail.includes('') 
            ? setRequireDetails(true)
            : setRequireDetails(false)

        const validFullfillment = Object.values(fullfillmentDetail)
        validFullfillment.includes('')
            ? setRequireFullfill(true)
            : setRequireFullfill(false)

        const validPublicDetail = Object.values(publicDetail)
        validPublicDetail.includes('')
            ? setRequirePublicDetails(true)
            : setRequirePublicDetails(false)

        const validOwnership = Object.values(businessOwner)
        validOwnership.includes('')
            ? setRequireOwner(true)
            : setRequireOwner(false)

        const validBusinessRepresent = Object.values(businessRepresent)
        validBusinessRepresent.includes('')
            ? setRequireRepresent(true)
            : setRequireRepresent(false)

        const validBankDetail = Object.values(bankDetail)
        validBankDetail.includes('')
            ? setRequireBankInfo(true)
            : setRequireBankInfo(false)

        const validAuth = Object.values(secureAccount)
        validAuth.includes('')
            ? setRequireAuth(true)
            : setRequireAuth(false)
    }

    const isDisabled = () => {
        let disable = false
        if(requireDetails || requireFullfill || requirePublicDetails || requireRepresent || requireOwner || requireBankInfo || requireAuth){
            disable = true
        }
        return disable
    }

    useEffect(() => {
        validate()
    }, [data])

    return (
        <div>
            {data === 'default' &&
                <div>
                    <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[42px]'>Review and finish up</h3>
                    <p className='text-[#414552] mt-2'>You’re almost ready to get started with Stripe. Take a moment to review and confirm your information.</p>
                    <div className="sm:mt-[40px] mt-[25px]">
                        <div>
                            <label className='text-[13px] mb-1 cursor-pointer text-[#1a1b25] font-semibold'>BUSINESS DETAILS</label>
                            <div className={`relative mt-1 w-full ${ requireDetails ? 'bg-[#fff8f5] border-[#cd3d64]' : 'bg-[#f7fafc] border-[#e3e8ee]' }  border-[1px] rounded-[6px] `}>
                                <div className='p-[12px_20px] border-b-[1px] border-[#ffe7f2] rounded-t-[6px] flex justify-between items-center'>
                                    <div className="flex gap-3 items-center text-[#1a1b25] font-medium text-sm">
                                        {requireDetails && <DangerIcon className="fill-[#fc526a]" />}
                                        {requireDetails ? 'Missing required' : 'Update business'} information
                                    </div>
                                    {requireDetails ? <button onClick={() => {setData('detail'); setIsUpdate(true)}} className='h-[30px] bg-[#f7fafc] text-[#414552] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'><PencilIcon />Update</button>
                                    : <button onClick={() => {setData('detail'); setIsUpdate(true)}}><PencilIcon /></button>}
                                </div>
                                <div className={`rounded-b-[6px] ${ requireDetails ? 'bg-[#fff5fa]' : 'bg-[#f7fafc]' } text-sm text-[#111b25] font-medium p-[12px_20px]`}>
                                    {businessDetail.business_name}
                                </div>
                            </div>
                            <div className={`mt-4 flex justify-between ${ requireFullfill ? 'bg-[#fff8f5] border-[#cd3d64]' : 'bg-[#f7fafc] border-[#e3e8ee]' } border-[1px] rounded-[6px] p-[12px_16px] text-sm text-[#1a1b25] font-medium`}>
                                <div className="flex gap-3 items-center text-[#1a1b25] font-medium text-sm">
                                    {requireFullfill && <DangerIcon className="fill-[#fc526a]" /> }
                                    {requireFullfill ? 'Missing' : 'Update'} product and fullfillment information
                                </div>
                                {requireFullfill ? <button onClick={() => {setData('fullfill'); setIsUpdate(true)}} className='h-[30px] bg-[#f7fafc] text-[#414552] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'><PencilIcon />Update</button>
                                : <button onClick={() => {setData('fullfill'); setIsUpdate(true)}}><PencilIcon /></button>}
                            </div>
                        </div>
                        <div className='mt-[25px]'>
                            <label className='text-[13px] mb-1 cursor-pointer text-[#1a1b25] font-semibold'>PUBLIC DETAILS</label>
                            <div className={`mt-2 items-start flex justify-between ${ requirePublicDetails ? 'bg-[#fff8f5] border-[#cd3d64]' : 'bg-[#f7fafc] border-[#e3e8ee]' } border-[1px] rounded-[6px] p-[12px_16px]`}>
                                <div className='text-[#1a1b25]'>
                                    <div className="flex gap-3 items-center text-[#1a1b25] font-medium text-sm">
                                        {requirePublicDetails && <DangerIcon className="fill-[#fc526a]" /> }
                                        <h3 className='font-medium'>{requirePublicDetails ? 'Missing' : 'Update'} support information</h3>
                                    </div>
                                    <h5 className='text-xs mt-[4px] font-normal'>Shown as {publicDetail.statement_descriptor !== '' ? publicDetail.statement_descriptor.toUpperCase() : 'YOUR BUSINESS NAME'} on customer statements</h5>
                                    <h5 className='text-xs mt-[4px] font-normal'>{publicDetail.customer_suport_phone}</h5>
                                </div>
                                {requirePublicDetails ? <button onClick={() => {setData('public'); setIsUpdate(true)}} className='h-[30px] bg-[#f7fafc] text-[#414552] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'><PencilIcon />Update</button>
                                : <button className='mt-1' onClick={() => {setData('public'); setIsUpdate(true)}}><PencilIcon /></button> }
                            </div>
                        </div>
                        <div className='mt-[25px]'>
                            <label className='text-[13px] mb-1 cursor-pointer text-[#1a1b25] font-semibold'>MANAGEMENT AND OWNERSHIP</label>
                            <div className={`relative mt-2 w-full ${ requireOwner ? 'bg-[#fff8f5] border-[#cd3d64]' : 'bg-[#f7fafc] border-[#e3e8ee]' } border-[1px] rounded-[6px]`}>
                                <div className='p-[12px_20px] rounded-t-[6px] flex justify-between items-center'>
                                    <div className="flex gap-3 items-center text-[#1a1b25] font-medium text-sm">
                                        {requireOwner && <DangerIcon className="fill-[#fc526a]" />}
                                        {requireOwner ? 'Missing' : 'Update' } business ownership information
                                    </div>
                                    {requireOwner ? <button onClick={() => {setData('Owners'); setIsUpdate(true)}} className='h-[30px] bg-[#f7fafc] text-[#414552] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'><PencilIcon />Update</button>
                                    : <button className='mt-1' onClick={() => {setData('Owners'); setIsUpdate(true)}}><PencilIcon /></button> }
                                </div>
                            </div>
                            <div className={`relative mt-3 w-full ${ requireRepresent ? 'bg-[#fff8f5] border-[#cd3d64]' : 'bg-[#f7fafc] border-[#e3e8ee]' } border-[1px] rounded-[6px]`}>
                                <div className='p-[12px_20px] rounded-t-[6px] flex justify-between items-center'>
                                    <div className="flex gap-3 items-center">
                                        {requireRepresent && <DangerIcon className="fill-[#fc526a]" />}
                                        <div className='text-[#1a1b25] font-medium text-sm'>
                                            <h3>{requireRepresent ? 'Missing required' : 'Update representative'} information</h3>
                                            <p className='text-xs font-normal text-[#414552]'>Account representative</p>
                                        </div>
                                    </div>
                                    {requireRepresent ? <button onClick={() => {setData('represent'); setIsUpdate(true)}} className='h-[30px] bg-[#f7fafc] text-[#414552] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'><PencilIcon />Update</button>
                                    : <button onClick={() => {setData('represent'); setIsUpdate(true)}}><PencilIcon /></button>}
                                </div>
                            </div>
                            {requireOwner &&
                                <button onClick={() => {setData('addOwner'); setIsUpdate(true)}} className="input_focus_shadow rounded-md mt-2 flex items-center gap-1 font-medium h-[30px] pl-2 pr-3 py-2 justify-center text-[#414552] text-sm w-full">
                                    <BiPlus className="text-[20px]" />
                                    Add an owner
                                </button> }
                        </div>
                        <div className='mt-[25px]'>
                            <label className='text-[13px] mb-1 cursor-pointer text-[#1a1b25] font-semibold'>PAYOUT DETAILS</label>
                            <div className={`relative mt-2 w-full ${ requireBankInfo? 'bg-[#fff8f5] border-[#cd3d64]' : 'bg-[#f7fafc] border-[#border]' } border-[1px] rounded-[6px]`}>
                                <div className='p-[12px_20px] rounded-t-[6px] flex justify-between items-center'>
                                    <div className="flex gap-3 items-center">
                                        {requireBankInfo && <DangerIcon className="fill-[#fc526a]" /> }
                                        <div className='text-[#1a1b25] font-medium text-sm'>
                                            <h3>{requireBankInfo ? 'Missing' : 'Update'} a bank account</h3>
                                            <p className='text-xs font-normal text-[#414552]'>Add a bank account where you'll receive your payouts.</p>
                                        </div>
                                    </div>
                                    {requireBankInfo ? <button onClick={() => {setData('addBank'); setIsUpdate(true)}} className='h-[30px] bg-[#f7fafc] text-[#414552] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-1'><BiPlus className='text-[20px]' />Add</button>
                                    : <button onClick={() => {setData('addBank'); setIsUpdate(true)}}><PencilIcon /></button>}
                                </div>
                            </div>
                        </div>
                        <div className='mt-[25px]'>
                            <label className='text-[13px] mb-1 cursor-pointer text-[#1a1b25] font-semibold'>TWO-STEP AUTHENTICATION</label>
                            <div className={`relative mt-2 w-full ${ requireAuth ? 'bg-[#fff8f5] border-[#cd3d64]' : 'bg-[#f7fafc] border-[#e3e8ee]' } border-[1px] rounded-[6px]`}>
                                <div className='p-[12px_20px] rounded-t-[6px] flex justify-between items-center'>
                                    <div className="flex gap-3 items-center">
                                        {requireAuth && <DangerIcon className="fill-[#fc526a]" />}
                                        <div className='text-[#1a1b25] font-medium text-sm'>
                                            <h3>{requireAuth ? 'Not enabled' : 'Update authentication'}</h3>
                                            <p className='text-xs font-normal text-[#414552]'>Set up two-factor authentication to protect your account.</p>
                                        </div>
                                    </div>
                                    {requireAuth ? <button onClick={() => {setData('secureAccount'); setIsUpdate(true)}} className='h-[30px] bg-[#f7fafc] text-[#414552] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-1'><BiPlus className='text-[20px]' />Add</button>
                                    : <button onClick={() => {setData('secureAccount'); setIsUpdate(true)}}><PencilIcon /></button>}
                                </div>
                            </div>
                        </div>
                        <p className='text-[#414552] mt-4 text-xs'>By submitting this form, you agree to the <span className='font-semibold text-[#625afa]'>Stripe Services Agreement</span>, to receiving text messages from Stripe, and you certify that the information provided is complete and correct.</p>

                        <div className='mt-6 pb-5'>
                            <button
                                onClick={handlesubmit}
                                disabled={isDisabled()}
                                className={`${isDisabled() && "opacity-60"} rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]`}>Agree & submit</button>
                        </div>
                    </div>
                </div>
            }

            {data === 'detail' &&
                <>
                    <BusinessDetails setStep={setStep} businessDetail={businessDetail} setBusinessDetail={setBusinessDetail} isUpdate={isUpdate} setMainStep={setMainStep} setData={setData} />
                    <div className='pb-5'>
                        <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow rounded-md w-full -mt-2 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Cancel</button>
                    </div>
                </>
            }
            {data === 'fullfill' &&
                <>
                    <FullfillDetails setStep={setStep} setMainStep={setMainStep} fullfillmentDetail={fullfillmentDetail} setFullfillmentDetail={setFullfillmentDetail} isUpdate={isUpdate} setData={setData} />
                    <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow rounded-md w-full -mt-2 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Save for later</button>
                </>
            }
            {data === 'public' &&
                <>
                    <PublicDetails setStep={setStep} setMainStep={setMainStep} publicDetail={publicDetail} setPublicDetail={setPublicDetail} isUpdate={isUpdate} setData={setData} />
                    <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow rounded-md w-full -mt-2 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Cancel</button>
                </>
            }
            {data === 'Owners' &&
                <>
                    <BusinessOwners setStep={setStep} setMainStep={setMainStep} businessOwner={businessOwner} setBusinessOwner={setBusinessOwner} isUpdate={isUpdate} setData={setData} />
                    <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow rounded-md w-full -mt-2 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Cancel</button>
                </>
            }
            {data === 'represent' &&
                <>
                    <BusinessRepresent setStep={setStep} setMainStep={setMainStep} businessRepresent={businessRepresent} setBusinessRepresent={setBusinessRepresent} isUpdate={isUpdate} setData={setData} />
                    <div className='pb-5'>
                        <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow rounded-md w-full -mt-2 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Cancel</button>
                    </div>
                </>
            }
            {data === 'addOwner' &&
                <>
                    <div className='mt-[0px]'>
                        <div>
                            <label htmlFor="legal-name" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Legal name</label>
                            <div className="relative mt-2 w-full">
                                <input type='text' id="legal-name" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='First name' />
                                <input type='text' id="legal-name" className="mt-2 input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Last name' />
                            </div>
                        </div>
                        <div className='mt-[32px]'>
                            <label htmlFor="Email-address" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Email address</label>
                            <div className="relative mt-2 w-full">
                                <input type='text' id="Email-address" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='person@example.com' />
                            </div>
                        </div>
                        <div className='mt-10 pb-5'>
                            <button className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Add</button>
                            <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow mb-7 rounded-md w-full mt-3 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Cancel</button>
                        </div>
                    </div>
                </>
            }
            {data === 'addBank' &&
                <>
                    <BankDetails setStep={setStep} setMainStep={setMainStep} bankDetail={bankDetail} setBankDetail={setBankDetail} isUpdate={isUpdate} setData={setData} />
                    <div className='pb-5'>
                        <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow rounded-md w-full -mt-2 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Cancel</button>
                    </div>
                </>
            }
            {data === 'secureAccount' &&
                <>
                <SecureAccount setStep={setStep} setMainStep={setMainStep} SetSecureAccount={SetSecureAccount} isUpdate={isUpdate} setData={setData}/>
                    <div className='pb-5'>
                        <button onClick={() => {setData('default'); setIsUpdate(false)}} className="input_focus_shadow rounded-md w-full -mt-2 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">Cancel</button>
                    </div>
                </>
            }
        </div>
    )
}

export default StepSummary